module.exports = __webpack_public_path__ + "static/media/fast-moving-newsletter.354a051d.jpg";